import Vue from 'vue'
import store from '@/store'

function k2vOptions (key, options) {
  if (!key) {
    return key
  }
  for (let item of options) {
    if (item.value === key) {
      return item.text
    }
  }
  return key
}

const f = {
  gameFormat (key) {
    return k2vOptions(key, store.getters.games)
  },
  channelFormat (key) {
    return k2vOptions(key, store.getters.channels)
  },
  serverFormat (key) {
    return k2vOptions(key, store.getters.servers)
  },
  autoConvert (key, value) {
    if (key === 'cid') {
      return this.channelFormat(parseInt(value))
    }
    if (key === 'sid') {
      return this.serverFormat(parseInt(value))
    }
    return value
  }
}

Vue.filter('game', function (key) {
  return f.gameFormat(key)
})

Vue.filter('channel', function (key) {
  return f.channelFormat(key)
})

Vue.filter('server', function (key) {
  return f.serverFormat(key)
})

export default f



// WEBPACK FOOTER //
// ./src/filter/index.js